<template>
    <div class="data-fill">
        <div class="container">
            <div class="entry" v-for="(entry, index) in entries" v-if="!entry.hidden" :key="index" v-bind:style="{'margin-bottom': index === entries.length - 1 ? '10px' : ''}">
                <div class="label">{{entry.label}}</div>
                <div class="data">
                    <searchbar class="searchbar"  v-if="entry.searchbar" :searchbar="entry.searchbar"/>
                    <i class="fas fa-check-circle checkbox" v-if="entry.type === 'bool'" v-bind:class="{false: !entry.value}" v-on:click="entry.value = !entry.value"></i>
                    <i class="fas fa-calendar-alt" v-if="entry.type === 'datearray'" v-on:click="OpenDatePickerArray($event, entry)"></i>
                    <input v-if="entry.type === 'timeframe'" min="0" max="24" v-model="entry.hours" type="number" class="label timeframe" v-on:keyup="UpdateTimeValue($event, entry)"/>
                    <div class="label hour" v-if="entry.type === 'timeframe'">:</div>
                    <input v-if="entry.type === 'timeframe'" min="0" max="59" v-model="entry.minutes" type="number" class="label timeframe" v-on:keyup="UpdateTimeValue($event, entry)"/>

                    <input v-if="entry.type === 'date'" min="1900" max="2100" v-model="entry.year" type="number" class="label timeframe year" v-on:keyup="UpdateDateValue($event, entry)"/>
                    <div class="label hour" v-if="entry.type === 'date'">/</div>
                    <input v-if="entry.type === 'date'" min="1" max="12" v-model="entry.month" type="number" class="label timeframe" v-on:keyup="UpdateDateValue($event, entry)"/>
                    <div class="label hour" v-if="entry.type === 'date'">/</div>
                    <input v-if="entry.type === 'date'" min="1" v-bind:max="entry.value.daysInMonth()" v-model="entry.date" type="number" class="label timeframe" v-on:keyup="UpdateDateValue($event, entry)"/>
                    <i class="fas fa-calendar-alt" v-if="entry.type === 'date'" v-on:click="OpenDatePicker($event, entry)"></i>

                    <input class="input numeric" v-if="entry.type === 'numeric'" type="number" v-bind:min="entry.min" v-bind:max="entry.max" v-model="entry.value"/>
                    <input class="input numeric" v-if="entry.type === 'text'" v-bind:maxlength="entry.length" v-model="entry.value"/>
                </div>
            </div>
            <div class="button accept" v-bind:class="{disabled: loading}" v-on:click="Accept()">
                <div class="label" v-if="!loading">Accept</div>
                <div v-if="loading" class="loading">
                    <i class="fas fa-spinner"></i>
                </div>
            </div>
            <div class="button decline" v-bind:class="{disabled: loading}" v-on:click="Cancel()">
                <div class="label" v-if="!loading">Cancel</div>
                <div v-if="loading" class="loading">
                    <i class="fas fa-spinner"></i>
                </div>
            </div>
        </div>
        <datepickerarray :state="datepickerarrayState" ref="datepickerarray" v-on:datepickerarray-dates-picked="OnDateArrayPicked"></datepickerarray>
        <datepicker :state="datepickerState" ref="datepicker" v-on:datepicker-date-picked="PickDate"></datepicker>
    </div>
</template>

<script>
    import searchbar from './searchbar.vue'
    import datepickerarray from './datepickerarray.vue'
    import datepicker from './datepicker.vue'
    export default {
        name: "datafill",
        components: {
            searchbar,
            datepickerarray,
            datepicker,
        },

        created(){
            var message = this;

        },
        destroyed () {
        },
        data(){
            return{
                header: '',
                description: '',
                type: '',
                type: 'html',
                timer: 0,
                hidden: false,
                loading: false,
                entries: [],
                data: {},
                selectCallback: function(data){},
                parentComponent: null,
                datepickerarrayState: {
                    toggled: false,
                    monthView: true,
                    posx: window.mouse.x,
                    posy: window.mouse.y,
                    date: this.$helpers.getCurrentMonthMomentUTC(),
                    selectedDate: this.$helpers.getCurrentMonthMomentUTC(),
                    dateArray: [],
                    yearView: true,
                },
                datepickerState: {
                    toggled: false,
                    monthView: true,
                    posx: window.mouse.x,
                    posy: window.mouse.y,
                    date: this.$helpers.getCurrentMonthMomentUTC(),
                    selectedDate: this.$helpers.getCurrentMonthMomentUTC(),
                    yearView: false,
                },
            }

        },
        methods: {
            Init(header, entries, selectCallback, parentComponent){

                this.header = header;
                //this.data = data;
                this.entries = entries;
                this.selectCallback = selectCallback;
                this.parentComponent = parentComponent;
                var view = this;

                requestAnimationFrame(function(){
                    view.CalculateWidths();
                });
            },
            PickDate(date){
                this.entryToUpdate.year = date.year();
                this.entryToUpdate.month = date.month() + 1; //hurr I'm momentjs november is the tenth month of the year
                this.entryToUpdate.date = date.date();
                this.entryToUpdate.value = date.clone();
                this.$forceUpdate();
            },
            OnDateArrayPicked(dateArray){
                //actually since it's the same array and not a .slice it would work regardless though cancel doesn't cancel
            },
            OpenDatePicker($event, entry){
                var box = $event.currentTarget.getBoundingClientRect();
                this.entryToUpdate = entry;
                this.datepickerState = {
                    toggled: true,
                    monthView: false,
                    posx: box.right + 15,
                    posy: box.top,
                    date: entry.value.clone(),
                    selectedDate: entry.value.clone(),
                    yearView: false,
                };
            },
            OpenDatePickerArray($event, entry){
                var box = $event.currentTarget.getBoundingClientRect();
                this.datepickerarrayState = {
                    toggled: true,
                    monthView: false,
                    posx: box.right + 15,
                    posy: box.top,
                    date: this.$helpers.getMomentUTC().month(0).date(1),
                    selectedDate: this.$helpers.getMomentUTC().month(0).date(1),
                    dateArray: entry.value,
                    yearView: true,
                };
            },
            UpdateTimeValue($event, entry){
                entry.value.hours(entry.hours).minutes(entry.minutes);
            },
            UpdateDateValue($event, entry){
                entry.value.year(entry.year).month(entry.month - 1).date(entry.date);
            },
            CalculateWidths(){
                var labels = $(this.$el).find('.container > .entry > .label').toArray();
                var maxWidth = labels.reduce(function (p, v) {
                    return ( p.offsetWidth > v.offsetWidth ? p : v );
                  }).offsetWidth;
                  $(this.$el).find('.container > .entry > .label').css('width', maxWidth + 'px');
                var data = $(this.$el).find('.container > .entry > .data').toArray();
                var maxWidth = data.reduce(function (p, v) {
                    return ( p.offsetWidth > v.offsetWidth ? p : v );
                  }).offsetWidth;
                  var temp = this.entries.filter(e => e.type === 'searchbar');
                  var searchbars = [];
                  temp.forEach(t => searchbars.push(t.searchbar));
                  if(searchbars.length > 0 && searchbars.find(s => s.items.find(i => (i.label.length * 5) > maxWidth))) {
                      var allItems = [];
                      searchbars.forEach(s => allItems = allItems.concat(s.items));
                      var maxLengthLabel = allItems.reduce(function (a, b) {
                          return ( a.label.length > b.label.length ? a : b );
                      }).label;
                      console.log(maxLengthLabel);
                      maxWidth = maxLengthLabel.length * 7;
                   }
                $(this.$el).find('.container .entry .data').css('width', maxWidth + 'px');
                $(this.$el).find('.container .entry .data .searchbar').css('width', maxWidth + 'px');
            },


            Accept(){
                var data = {};
                for(var x in this.entries){
                    var entry = this.entries[x];
                    
                    if(entry.type !== 'searchbar') data[entry.key] = entry.value;
                    else {
                        if(entry.selectMultiple) {
                            var selectedItems = [];
                            entry.searchbar.selectedItems.forEach(i => selectedItems.push(i.value));
                            data[entry.key] = selectedItems;
                        }
                        else {
                            if(entry.searchbar.selectedItem){
                                data[entry.key] = entry.searchbar.selectedItem.value;
                            } else {
                                data[entry.key] = null;
                            }
                            
                        } 
                    }
                }
                this.entries = [];
                if(this.loading) return;
                if(this.selectCallback) this.selectCallback(data);
                if(this.parentComponent) this.parentComponent.Toggle(false);
                else this.hidden = true;
            },
            Cancel(){
                this.entries = [];
                if(this.loading) return;
                if(this.callbackCancel) this.callbackCancel(this);
                if(this.parentComponent) this.parentComponent.Toggle(false);
                else this.hidden = true;
            },
        },
        props:{
        }
    }
</script>

<style scoped>

.data-fill{
    text-align: center;
}

.header{
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: inset 0 -2px 0 -1px var(--contrast-2);
}

.header .label{
        font-size: 20px;
    width: 100%;
    text-align: left;
}

.entry{
        display: block;
}

.entry .label{
        display: inline-block;
        height: 25px;
        text-align: right;
        margin-right: 5px;
        white-space: pre;
}

.entry .data{
    display: inline-block;
    text-align: initial;

}

.entry .data .checkbox{
    float: left;
    transform: scale(1.2) translateY(3px);

}
.entry .data input{
    width: 100%;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    height: 25px;
    background: none;
    border-radius: 0;
    box-shadow: inset 0 -2px 0 -1px var(--contrast-5);
}

.entry .data input.timeframe{
    width: 20px;
    display: inline-block;
    padding: 0;
}
.entry .data .searchbar{
    position: absolute;
    margin-top: -16px;
    margin-left: 0px;
    z-index: initial;
}
.button{
    margin: 0 7.5px;
    margin-bottom: 10px;
    min-width: 55px;
}

.entry .data input.timeframe.year{
    width: 30px;
}

.fa-calendar-alt{
    color: var(--contrast-4);
}
</style>